import { useReveal } from "@/hooks/useReveal";
import { useLanguage } from "@/i18n/LanguageContext";
import RoomCarousel from "@/components/site/RoomCarousel";

const A = "https://customer-assets.emergentagent.com/job_novi-hotel/artifacts";

const ROOM_META = {
  deluxe: {
    index: "01",
    images: [
      { src: `${A}/h2tcxqy5_B5F190F3-5C71-4FC2-9866-9FA89F6EE1D9.png`, alt: "Camera doppia — letto matrimoniale" },
      { src: `${A}/jis9kpa0_DSC00167%20ed.jpg`, alt: "Camera doppia — bagno con doccia in pietra" },
      { src: `${A}/9w93scid_DSC00134%20ed.jpg`, alt: "Camera doppia — letti gemelli con vista" },
      { src: `${A}/lko2xs9u_DSC00111%20ed.jpg`, alt: "Camera doppia — vista interna" },
      { src: `${A}/8zzo11f3_DSC00146%20ed.jpg`, alt: "Camera doppia — vista dalla finestra" },
    ],
    reverse: false,
  },
  junior: {
    index: "02",
    images: [
      { src: `${A}/w13jr30u_F8B60554-37B2-4455-86BB-B09684034DD4.png`, alt: "Camera singola — letto" },
      { src: `${A}/0p4c9woa_DSC00074%20ed.jpg`, alt: "Camera singola — scrivania e mini-frigo" },
      { src: `${A}/6nzp5buc_DSC00128%20ed.jpg`, alt: "Camera singola — bagno con doccia" },
      { src: `${A}/d2th2jdd_DSC00101%20ed.jpg`, alt: "Camera singola — bagno" },
    ],
    reverse: true,
  },
  suite: {
    index: "03",
    images: [
      { src: `${A}/vlmcok09_2D8AC323-2047-41B3-AE3E-5A888E641B33.png`, alt: "Camera tripla — tre letti singoli" },
      { src: `${A}/b2h7y01w_DSC00083%20ed.jpg`, alt: "Camera tripla — vista interna" },
      { src: `${A}/epju8c8w_DSC00123%20ed.jpg`, alt: "Camera tripla — bagno" },
    ],
    reverse: false,
  },
};

function RoomRow({ room, t }) {
  const ref = useReveal();
  const meta = ROOM_META[room.id];

  return (
    <article
      ref={ref}
      data-testid={`room-card-${room.id}`}
      className="reveal grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center"
    >
      <div className={`lg:col-span-7 ${meta.reverse ? "lg:order-2" : ""}`}>
        <RoomCarousel images={meta.images} name={room.name} />
      </div>

      <div className={`lg:col-span-5 ${meta.reverse ? "lg:order-1" : ""}`}>
        <div className="flex items-baseline gap-4 mb-4">
          <span className="font-serif-display text-xl text-[#A88B7D]">
            /{meta.index}
          </span>
          <span className="overline">{t.rooms.labelRoom}</span>
        </div>
        <h3
          data-testid={`room-title-${room.id}`}
          className="font-serif-display text-4xl md:text-5xl font-light tracking-tight text-[#1A1C19] leading-[1.05]"
        >
          {room.name}
        </h3>

        <p className="mt-6 text-base md:text-lg text-[#5C6058] leading-relaxed">
          {room.description}
        </p>

        <a
          href="#contatti"
          data-testid={`room-inquire-${room.id}`}
          onClick={(e) => {
            e.preventDefault();
            document
              .querySelector("#contatti")
              ?.scrollIntoView({ behavior: "smooth" });
          }}
          className="btn-ghost mt-8"
        >
          {t.rooms.inquire}
        </a>
      </div>
    </article>
  );
}

export default function Rooms() {
  const headRef = useReveal();
  const { t } = useLanguage();

  return (
    <section
      id="camere"
      data-testid="rooms-section"
      className="py-24 md:py-36 bg-[#FAF9F5]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <div ref={headRef} className="reveal max-w-3xl mb-20 md:mb-28">
          <span className="overline block mb-5">{t.rooms.overline}</span>
          <h2 className="font-serif-display text-4xl md:text-6xl font-light tracking-tight text-[#1A1C19] leading-[1.02]">
            {t.rooms.titleLine1}
            <span className="italic block text-[#363A33]">
              {t.rooms.titleLine2}
            </span>
          </h2>
          <p className="mt-6 text-base md:text-lg text-[#5C6058] leading-relaxed">
            {t.rooms.description}
          </p>
        </div>

        <div className="flex flex-col gap-24 md:gap-36">
          {t.rooms.list.map((r) => (
            <RoomRow key={r.id} room={r} t={t} />
          ))}
        </div>
      </div>
    </section>
  );
}
